import * as dialog from '../dialog';
import * as form from '../form';
import * as v2 from '../v2';

type lang = 'en' | 'ja';

class SessionTimeout {
  private readonly messages = {
    en: {
      m1: 'You will be logged out in 5 minutes.',
      m2: 'You will be logged out due to inactivity for 30 minutes. If you wish to continue, press the [Continue] button.',
      button: 'Continue',
    },
    ja: {
      m1: '5分後に自動的にログアウトします。',
      m2: '30分以上データが更新されていないため、自動的にログアウトします。「作業を続ける」ボタンをクリックしてください。',
      button: '作業を続ける',
    },
  };
  private soft = 0;
  private hard = 0;
  constructor() {
    this.setTimeout();
  }
  async setTimeout() {
    const min = 1000 * 60;
    await new Promise<void>(resolve => {
      this.soft = setTimeout(resolve, min * 30);
    });
    const handler: TimerHandler = () => {
      form.Form.changed = false;
      v2.Form.changed = false;
      if (opener)
        close();
      location.href = `/${location.pathname.split('/')[1]}/logout`;
    };
    this.hard = setTimeout(handler, min * 5);
    const lang = document.documentElement.lang;
    const messages = this.messages[lang as lang];
    await dialog.alert(messages.m2, {title: messages.m1, ok: messages.button});
    this.clearTimeout();
    this.submit();
  }
  clearTimeout() {
    clearTimeout(this.soft);
    clearTimeout(this.hard);
  }
  submit() {
    const selector = 'form[name="session"]';
    const form = document.querySelector(selector) as HTMLFormElement;
    fetch(form.action, {method: form.method, body: new FormData(form)});
    this.setTimeout();
  }
}

window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('form[name="session"]')) {
    new SessionTimeout;
  }
});
